import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Users } from "lucide-react";

interface RetentionBlockProps {
    percentage: number;
}

const RetentionBlock: React.FC<RetentionBlockProps> = ({ percentage }) => {
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">Customer Retention Rate</CardTitle>
                <Users className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
                <div className="font-display text-2xl font-bold">{percentage?.toFixed(1) ?? 0}%</div>
                <p className="text-xs text-muted-foreground">
                    of customers have ordered more than once
                </p>
            </CardContent>
        </Card>
    );
};

export default RetentionBlock;
